import React, { Component } from 'react'
import { Card, CardContent, CardActions, Typography, Avatar, TextField, IconButton, Button, Grid, Alert, InputAdornment, FormControl, Select, MenuItem, InputLabel, CardHeader, Snackbar } from '@mui/material';
import "./style.css"
import { RiPencilFill } from "react-icons/ri";
import validate from 'validate.js';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

validate.validators.passwordComplexity = function (value, options, key, attributes) {
    const minLength = options.minLength || 8;
    const hasNumber = /\d/.test(value);
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);

    if (!value || value.length < minLength) {
        return "^Must be at least 8 characters long and should contain a number, an upper case alphabet, a lower case alphabet and a special character";
    }

    if (!hasNumber || !hasUpperCase || !hasLowerCase || !hasSpecialChar) {
        return "^Must be at least 8 characters long and should contain a number, an upper case alphabet, a lower case alphabet and a special character";
    }
};


class SFProfile extends Component {

    profileSchema = {
        firstName: {
            presence: {
                allowEmpty: false,
                message: '^Please enter your first name'
            },
            length: { minimum: 1 }
        },
        lastName: {
            presence: {
                allowEmpty: false,
                message: '^Please enter your last name'
            },
            length: { minimum: 1 }
        },

    }

    passwordSchema = {
        password1: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
            passwordComplexity: {
                minLength: 8,
            }
        },
        password2: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
            equality: {
                attribute: "password1",
                message: "^Passwords does not match!",
            },
        },
    }

    defaultMessage = {
        show: false,
        type: '', // error, warning, success
        msg: '' // real message
    }
    constructor(props) {
        super(props);

        this.state = {
            editMode: false,
            firstName: '',
            lastName: '',
            pronoun: 0,
            emailID: '',
            password1: '',
            password2: '',
            profileErrors: null,
            passwordErrors: null,
            message: this.defaultMessage,
            showPassword1: false,
            showPassword2: false,
            type: null,
        }
    }

    componentDidMount() {
        this.getUserDetails();
        this.setState({
            message: this.defaultMessage,
        });
    }

    handleEditBtnClick = () => {
        this.setState({
            editMode: true,
            message: this.defaultMessage,
        })
    }

    handleEditCancel = () => {
        this.setState({
            editMode: false,
            message: this.defaultMessage,
            profileErrors: null
        })
        console.debug("this.defaultMessage", this.defaultMessage)
    }

    getUserDetails = () => {
        const response = this.props.apiService({
            method: 'get',
            url: '/getUserDetailsByUserName'
        });

        response.then(res => {
            console.debug("res.data.status", res.data.status);
            if (res && res.data.status === 0) {
                const userData = res.data.data;
                this.setState({
                    firstName: userData?.firstName,
                    lastName: userData?.lastName,
                    emailID: userData?.emailid,
                    pronoun: userData?.pronoun,
                });
            } else {

            }
        });
    }

    handleFieldChange = (fieldID, value) => {
        this.setState({
            [fieldID]: value
        })
    }

    profileValidation = (data) => {
        let errors = validate(data, this.profileSchema);

        this.setState({
            profileErrors: errors,
        })

        return errors === undefined || Object.keys(errors).length === 0;
    }

    passwordValidation = (data) => {
        let errors = validate(data, this.passwordSchema);

        this.setState({
            passwordErrors: errors,
        })

        return errors === undefined || Object.keys(errors).length === 0;
    }

    handleUpdateProfile = () => {
        this.setState({type: null})
        let data = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailID: this.state.emailID,
        }
        console.debug("data", data)
        if (!this.profileValidation(data)) {
            return
        }

        let payload = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            pronoun: this.state.pronoun,
            emailID: this.state.emailID,
        }

        const response = this.props.apiService({
            method: 'post',
            url: '/updateProfile',
            data: payload
        });

        response.then(res => {
            let type = '';
            let msg = '';
            if (res && res.data.status === 0) {
                type = 'success';
                msg = "Successfully updated your profile";
                this.setState({
                    editMode: false
                })
            } else {
                type = 'error';
                msg = res.data?.message;
            }

            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                },
                type: 'profile',
            })
        })
    }

    handleUpdatePassword = () => {
        this.setState({type: null})
        let data = {
            password1: this.state.password1,
            password2: this.state.password2,
        }
        console.debug("data", data)
        if (!this.passwordValidation(data)) {
            return
        }

        let payload = {
            password: this.state.password2,
        }

        const response = this.props.apiService({
            method: 'post',
            url: '/updatePassword',
            data: payload
        });

        response.then(res => {
            let type = '';
            let msg = '';
            if (res && res.data.status === 0) {
                type = 'success';
                msg = "Successfully updated your password";
                this.setState({
                    password1: "",
                    password2: "",
                    showPassword1: false,
                    showPassword2: false,
                })
            } else {
                type = 'error';
                msg = res.data?.message;
            }

            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                },
                type: 'password'
            })
        })
    }

    render() {
        const { firstName, lastName, pronoun, emailID, password1, password2, profileErrors, passwordErrors, showPassword1, showPassword2 } = this.state;
        return (
            <div className='sf-profile-container'>
                <Typography variant='h4' className='mb-2' fontWeight={'500'} >Manage Profile</Typography>
                <Grid container spacing={2} className='mt-2'>
                    <Grid item md={5}>
                        <Card style={{minHeight:"220px"}}>
                            <CardContent className='pt-5 pb-3 position-relative'>
                                <Grid container spacing={4} justifyContent={'center'}>
                                    {/* Profile picture */}
                                    <Grid item md={2} >
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <Avatar sx={{ width: 100, height: 100, fontSize: '3rem' }}>
                                                {firstName ? firstName.charAt(0) : ""}
                                            </Avatar>
                                        </div>
                                    </Grid>

                                    {/* Fields */}
                                    <Grid item md={8} xs={12} className='sf-profile-fields' >
                                        <Grid container spacing={2} >
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    InputProps={{
                                                        // disableUnderline: !this.state.editMode,
                                                        readOnly: !this.state.editMode,
                                                    }}
                                                    fullWidth
                                                    id="firstName"
                                                    label="First Name"
                                                    variant="outlined"
                                                    value={firstName}
                                                    sx={{
                                                        "& fieldset": { border: !this.state.editMode ? 'none' : '' },
                                                    }}
                                                    onChange={(event) => {
                                                        let value = event.target.value;
                                                        this.handleFieldChange("firstName", value);
                                                    }}
                                                    error={(profileErrors && profileErrors['firstName']) ? true : false}
                                                    helperText={profileErrors && profileErrors['firstName'] ? profileErrors['firstName'][0] : ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField InputProps={{
                                                    //disableUnderline: !this.state.editMode,
                                                    readOnly: !this.state.editMode,
                                                }}
                                                    fullWidth
                                                    id="lastName"
                                                    label="Last Name"
                                                    variant="outlined"
                                                    value={lastName}
                                                    sx={{
                                                        "& fieldset": { border: !this.state.editMode ? 'none' : '' },
                                                    }}
                                                    onChange={(event) => {
                                                        let value = event.target.value;
                                                        this.handleFieldChange("lastName", value);
                                                    }}
                                                    error={(profileErrors && profileErrors['lastName']) ? true : false}
                                                    helperText={profileErrors && profileErrors['lastName'] ? profileErrors['lastName'][0] : ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="pronoun-id  label">Pronoun</InputLabel>
                                                    <Select
                                                        readOnly={!this.state.editMode}
                                                        labelId="pronoun-id"
                                                        id="pronoun"
                                                        value={pronoun !== 0 ? pronoun : ''}
                                                        label="Pronoun"
                                                        onChange={(event) => {
                                                            let value = event.target.value;
                                                            this.handleFieldChange("pronoun", value);
                                                        }}
                                                        sx={{
                                                            "& fieldset": { border: !this.state.editMode ? 'none' : '' },
                                                        }}
                                                    >
                                                        <MenuItem value={1}>he/him/his</MenuItem>
                                                        <MenuItem value={2}>she/her/hers</MenuItem>
                                                        <MenuItem value={3}>they/them/their</MenuItem>
                                                        <MenuItem value={4}>prefer not to say</MenuItem>
                                                        <MenuItem value={5}>ask me about my pronouns</MenuItem>
                                                        <MenuItem value={6}>other pronouns/not listed</MenuItem>
                                                        <MenuItem value={7}>none</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {/* <TextField InputProps={{
                                            //disableUnderline: !this.state.editMode,
                                            readOnly: !this.state.editMode,
                                        }}
                                            fullWidth
                                            id="pronoun"
                                            label="Pronoun"
                                            variant="outlined"
                                            value={"She/Her"}
                                            sx={{
                                                "& fieldset": { border: !this.state.editMode ? 'none' : '' },
                                            }} /> */}
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    disabled
                                                    fullWidth
                                                    id="emailID"
                                                    label="Email"
                                                    variant="outlined"
                                                    value={emailID}
                                                    sx={{
                                                        "& fieldset": { border: !this.state.editMode ? 'none' : '' },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        {this.state.type === "profile" ?
                                            <Alert
                                                hidden={!this.state.message.show}
                                                severity={this.state.message.type}
                                                color={this.state.message.type}
                                                fontWeight={500}
                                                fontSize={14}
                                                className='mt-4 text-align-left'>
                                                {this.state.message.msg}
                                            </Alert>
                                            : null}
                                    </Grid>
                                </Grid>
                                {!this.state.editMode ?
                                    <div className='edit-profile-btn'>
                                        <IconButton aria-label="edit" size="medium" onClick={this.handleEditBtnClick}>
                                            <RiPencilFill fontSize="inherit" />
                                        </IconButton>
                                    </div>
                                    : null}

                            </CardContent>
                            {this.state.editMode ?
                                <CardActions className='d-flex justify-content-end'>
                                    <Button variant='outlined' onClick={this.handleEditCancel}>Cancel</Button>
                                    <Button variant='contained' onClick={this.handleUpdateProfile}>Update</Button>
                                </CardActions>
                                : null}
                        </Card>
                    </Grid>
                    <Grid item md={5}>
                        <Card style={{minHeight:"220px"}}>
                            <CardHeader title="Update Password"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField InputProps={{
                                            // disableUnderline: !this.state.editMode,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => this.setState({ showPassword1: !showPassword1 })}
                                                    >
                                                        {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                            fullWidth
                                            placeholder='Password'
                                            id="password1"
                                            label="Password"
                                            variant="outlined"
                                            type={showPassword1 ? 'text' : 'password'}
                                            value={password1}
                                            /*  sx={{
                                                 "& fieldset": { border: !this.state.editMode ? 'none' : '' },
                                             }} */
                                            onChange={(event) => {
                                                let value = event.target.value;
                                                this.handleFieldChange("password1", value);
                                            }}
                                            error={(passwordErrors && passwordErrors['password1']) ? true : false}
                                            helperText={passwordErrors && passwordErrors['password1'] ? passwordErrors['password1'][0] : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField InputProps={{
                                            // disableUnderline: !this.state.editMode,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => this.setState({ showPassword2: !showPassword2 })}
                                                    >
                                                        {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                            placeholder='Confirm Password'
                                            fullWidth
                                            id="password2"
                                            label="Confirm Password"
                                            variant="outlined"
                                            type={showPassword2 ? 'text' : 'password'}
                                            value={password2}
                                            /*  sx={{
                                                 "& fieldset": { border: !this.state.editMode ? 'none' : '' },
                                             }} */
                                            onChange={(event) => {
                                                let value = event.target.value;
                                                this.handleFieldChange("password2", value);
                                            }}
                                            error={(passwordErrors && passwordErrors['password2']) ? true : false}
                                            helperText={passwordErrors && passwordErrors['password2'] ? passwordErrors['password2'][0] : ''}
                                        />
                                    </Grid>
                                </Grid>
                                {this.state.type === "password" ?
                                    <Alert
                                        hidden={!this.state.message.show}
                                        severity={this.state.message.type}
                                        color={this.state.message.type}
                                        fontWeight={500}
                                        fontSize={14}
                                        className='mt-4 text-align-left'>
                                        {this.state.message.msg}
                                    </Alert>
                                    : null}
                            </CardContent>
                            <CardActions className='d-flex justify-content-end'>
                                <Button variant='contained' onClick={this.handleUpdatePassword}>Update</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}


export default SFProfile;